/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};







ShopifyAPI.updateCartNote = function (note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function (cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        }
        else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);

        document.dispatchEvent(new CustomEvent('cart:note:change'));

      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);

        document.dispatchEvent(new CustomEvent('cart:note:error'));

      },
      complete: function (jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);

        document.dispatchEvent(new CustomEvent('cart:note:complete'));

      }
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message);
  }
  window.location.reload();
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery(form).serialize(),
      dataType: 'json',
      beforeSend: function (jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function (line_item) {
        document.documentElement.classList.add("offCanvasBasket");
        juno.basketIsRevealed = true;
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        }
        else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);

        document.dispatchEvent(new CustomEvent('cart:lineitem:added'));

      },
      error: function (XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        }
        else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);

        document.dispatchEvent(new CustomEvent('cart:lineitem:error'));

      },
      complete: function (jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);

        document.dispatchEvent(new CustomEvent('cart:lineitem:complete'));

      }
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: function (cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        }
        else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);

        document.dispatchEvent(new CustomEvent('cart:lineitem:change'));
        if (document.querySelector('.template-cart')) {
          enableCartPageLoadingState(); // from store.js
          fetchAndUpdateCart(); // from store.js
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);

        document.dispatchEvent(new CustomEvent('cart:lineitem:error'));

      },
      complete: function (jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);

        document.dispatchEvent(new CustomEvent('cart:lineitem:complete'));

      }
    };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, updateProgressBar;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();

    document.dispatchEvent(new CustomEvent('cart:initialized'));
   
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat).replace(".00", ""));
    }




  };

  formOverride = function () {
    $formContainer.on('submit', function (evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added').delay(4000).queue(function (rvt) {
      $addToCart.removeClass('is-added');
      rvt();
    });
    $('#GoToCheckout').css('display', 'block');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        // $('.product-switcher').after('<div class="errors qty-error button-text">' + data.description + '</div>')
        alert(data.description);

        // sticky atc bar update
        initializeStickyAtcButton();
        // sticky atc bar update

      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

buildCart = function (cart) {
    if (window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function') {
      cart = BOLD.common.cartDoctor.fix(cart);
    }

    // Start with a fresh cart div
    $cartContainer.removeClass('empty').empty();

    // Show empty cart
    const emptyCartText = "Your bag is empty!"

// const UsNotification = document.querySelector('#us-notification-snippet')?.innerHTML || '';

// Embed the rendered snippet in your template literal
const emptyCartHeader = `<div class="ajax-cart-sticky-bar">
                              <div class="top-heading-bar">
                                <div class="close-cart-drawer" onclick="juno.checkToggleBasketNavigation()">
                                  <svg fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve">
                                    <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490   489.292,457.678 277.331,245.004 489.292,32.337 "/>
                                  </svg>
                                </div>
                                <h3>${emptyCartText}</h3>
                              </div>
                            </div>`;
if (cart.item_count === 0) {
  $cartContainer.addClass('empty').append(emptyCartHeader);
  cartCallback(cart);
  return;
}

// Handlebars.js cart layout
var items = [],
  item = {},
  data = {},
  source = $("#CartTemplate").html(),
  template = Handlebars.compile(source);





// Add each item to our handlebars.js data
$.each(cart.items, function (index, cartItem) {
  /* Hack to get product image thumbnail
   *   - If image is not null
   *     - Remove file extension, add _small, and re-add extension
   *     - Create server relative link
   *   - A hard-coded url of no-image
  */
  if (cartItem.image != null) {
    var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
  } else {
    var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
  }

  // Create item's data object and add to 'items' array
  item = {
    key: cartItem.key,
    line: index + 1, // Shopify uses a 1+ index in the API
    url: cartItem.url,
    img: prodImg,
    name: cartItem.product_title,
    variation: cartItem.variant_title,
    properties: cartItem.properties,
    itemAdd: cartItem.quantity + 1,
    itemMinus: cartItem.quantity - 1,
    itemQty: cartItem.quantity,
    price: Shopify.formatMoney(cartItem.price, settings.moneyFormat).replace(".00", ""),
    vendor: cartItem.vendor,
    linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat).replace(".00", ""),
    originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat).replace(".00", ""),
    discounts: cartItem.discounts,
    discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
    unformattedPrice: cartItem.price,
    unformattedLinePrice: cartItem.line_price,
    sku: cartItem.sku,
    type: cartItem.product_type
  };

  items.push(item);
});

// Gather all cart data and add to DOM
data = {
  items: items,
  note: cart.note,
  cartCount: cart.item_count,
  totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat).replace(".00", ""),
  totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat).replace(".00", "")),
    totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

$cartContainer.append(template(data));
if(Shopify.country == 'GB'){
  updateProgressBar(cart);
}
harperMiniCart = new Harper(harperMiniCartConfig);
// reinitialize the loyaltylion loyalty points components after live updating the cart
window?.loyaltylion && window?.loyaltylion?.ui?.refresh();

cartCallback(cart);
if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
  BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
}
  };

cartCallback = function (cart) {
  $body.removeClass('drawer--is-loading');
  $body.trigger('afterCartLoad.ajaxCart', cart);

  if (window.Shopify && Shopify.StorefrontExpressButtons) {
    Shopify.StorefrontExpressButtons.initialize();
  }

  document.dispatchEvent(new CustomEvent('cart:callback'));

};

adjustCart = function () {
  // Delegate all events because elements reload with the cart

  // Add or remove from the quantity
  $body.on('click', '.ajaxcart__qty-adjust', function () {
    if (isUpdating) {
      return;
    }

    var $el = $(this),
      line = $el.data('line'),
      $qtySelector = $el.siblings('.ajaxcart__qty-num'),
      qty = parseInt($qtySelector.val().replace(/\D/g, ''));
    var qty = validateQty(qty);
    var adjustmentType;

    // var gtmData = $qtySelector.closest('[data-product]').data('product');
    // gtmData.quantity = qty;

    // Add or subtract from the current quantity
    if ($el.hasClass('ajaxcart__qty--plus')) {
      qty += 1;
      adjustmentType = 'plus';
    } else {
      adjustmentType = 'minus';
      qty -= 1;
      if (qty <= 0) qty = 0;
    }

    // If it has a data-line, update the cart.
    // Otherwise, just update the input's number
    if (line) {
      updateQuantity(line, qty);
    } else {
      $qtySelector.val(qty);
    }

    if (adjustmentType === 'plus') {
      //triggerGTMAddToCart(gtmData);
    } else if (adjustmentType === 'minus') {
      //triggerGTMRemoveFromCart(gtmData);
    }

  });

  // Update quantity based on input on change
  $body.on('change', '.ajaxcart__qty-num', function () {
    if (isUpdating) {
      return;
    }

    var $el = $(this),
      line = $el.data('line'),
      qty = parseInt($el.val().replace(/\D/g, ''));

    var qty = validateQty(qty);

    // If it has a data-line, update the cart
    if (line) {
      updateQuantity(line, qty);
    }
  });

  // Prevent cart from being submitted while quantities are changing
  $body.on('submit', 'form.ajaxcart', function (evt) {
    if (isUpdating) {
      evt.preventDefault();
    }
  });

  // Highlight the text when focused
  $body.on('focus', '.ajaxcart__qty-adjust', function () {
    var $el = $(this);
    setTimeout(function () {
      $el.select();
    }, 50);
  });

  function updateQuantity(line, qty) {
    isUpdating = true;

    // Add activity classes when changing cart quantities
    var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

    if (qty === 0) {
      $row.parent().addClass('is-removed');
    }

    // Slight delay to make sure removed animation is done
    setTimeout(function () {
      ShopifyAPI.changeItem(line, qty, adjustCartCallback);
    }, 250);
  }

  // Save note anytime it's changed
  $body.on('change', 'textarea[name="note"]', function () {
    var newNote = $(this).val();

    // Update the cart note in case they don't click update/checkout
    ShopifyAPI.updateCartNote(newNote, function (cart) { });
  });

  // Setup listeners to remove product from cart
  // $('button.remove').on('click', function() {
  //   if (isUpdating) {
  //     return;
  //   }

  //   var $el = $(this),
  //       line = $el.data('line'),
  //       $qtySelector = $el.parent().parent().find('.js-qty__num'),
  //       qty = 0;

  //   // If it has a data-line, update the cart.
  //   // Otherwise, just update the input's number
  //   if (line) {
  //     updateQuantity(line, qty);
  //   } else {
  //     $qtySelector.val(qty);
  //   }

  //   // var gtmData = $qtySelector.closest('[data-product]').data('product');
  //   // gtmData.quantity = qty;

  //   //triggerGTMRemoveFromCart(gtmData);

  //   setTimeout(function() {
  //     location.reload();
  //   }, 500);
  // });
};

adjustCartCallback = function (cart) {
  // Update quantity and price
  updateCountPrice(cart);

  // Reprint cart on short timeout so you don't see the content being removed
  setTimeout(function () {
    isUpdating = false;
    ShopifyAPI.getCart(buildCart);
  }, 150)
};

/*============================================================================
  Update the free-shipping progress bar using live cart data.
  The Liquid snippet (progress-bar.liquid) is rendered once at page load;
  this function keeps it in sync whenever the cart changes.
==============================================================================*/
updateProgressBar = function (cart) {
  var threshold = 15000; // pence — must match the value in progress-bar.liquid
  var total = cart.total_price;
  var progress = Math.min(Math.floor(total * 100 / threshold), 100);
  var remaining = threshold - total;
  var $wrap = $('.fs-progress-wrap');
  var $fill = $('.fs-progress-fill');
  var $dot  = $('.fs-progress-dot');
  var $text = $('.fs-progress-text');
  if (!$wrap.length) return; // progress bar not present in current DOM
  // Update bar fill and dot position
  $fill.css('width', progress + '%');
  $dot.css('left', progress + '%');
  if (total >= threshold) {
    $wrap.addClass('is-complete');
    $text.text(" You've unlocked free shipping! ");
    $dot.html('&#10003;'); // ✓ checkmark
  } else {
    $wrap.removeClass('is-complete');
    var remainingFormatted = Shopify.formatMoney(remaining, settings.moneyFormat).replace('.00', '').replace(/<[^>]+>/g, '');;
    $text.text(' Spend ' + remainingFormatted + ' more to get free shipping ');
    $dot.html('<svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.73012 18.27C5.24345 17.7813 5.00012 17.1913 5.00012 16.5H2.77012L2.98812 15.5H5.25612C5.43679 15.0553 5.72845 14.694 6.13112 14.416C6.53379 14.1387 6.99012 14 7.50012 14C8.01012 14 8.46679 14.1387 8.87012 14.416C9.27212 14.694 9.56345 15.0553 9.74412 15.5H14.3621L16.5581 6H5.60812L5.63112 5.902C5.67979 5.64067 5.80645 5.425 6.01112 5.255C6.21579 5.085 6.45712 5 6.73512 5H17.8081L16.9981 8.5H19.0771L21.7891 12.116L20.9231 16.5H19.7691C19.7691 17.1927 19.5258 17.7827 19.0391 18.27C18.5525 18.7573 17.9625 19.0007 17.2691 19C16.5758 18.9993 15.9861 18.756 15.5001 18.27C15.0141 17.784 14.7708 17.194 14.7701 16.5H10.0001C10.0001 17.1927 9.75679 17.7827 9.27012 18.27C8.78345 18.7573 8.19345 19.0007 7.50012 19C6.80679 18.9993 6.21679 18.756 5.73012 18.27ZM15.8871 13.25H20.5391L20.7161 12.36L18.5771 9.5H16.7591L15.8871 13.25ZM16.3161 7.002L16.5581 6L14.3611 15.5L14.6041 14.498L15.3961 11.002L16.3161 7.002ZM1.67212 12.998L1.92212 11.998H6.40212L6.15212 12.998H1.67212ZM3.67212 9.502L3.92212 8.502H9.40212L9.15212 9.502H3.67212ZM7.50012 18C7.91145 18 8.26445 17.853 8.55912 17.559C8.85312 17.2643 9.00012 16.9113 9.00012 16.5C9.00012 16.0887 8.85312 15.7357 8.55912 15.441C8.26512 15.1463 7.91212 14.9993 7.50012 15C7.08812 15.0007 6.73512 15.1477 6.44112 15.441C6.14712 15.7357 6.00012 16.0887 6.00012 16.5C6.00012 16.9113 6.14712 17.2643 6.44112 17.559C6.73579 17.853 7.08879 18 7.50012 18ZM17.2701 18C17.6815 18 18.0341 17.853 18.3281 17.559C18.6221 17.2643 18.7691 16.9113 18.7691 16.5C18.7691 16.0887 18.6221 15.7357 18.3281 15.441C18.0341 15.1463 17.6811 14.9993 17.2691 15C16.8571 15.0007 16.5045 15.1477 16.2111 15.441C15.9165 15.7357 15.7691 16.0887 15.7691 16.5C15.7691 16.9113 15.9161 17.2643 16.2101 17.559C16.5048 17.853 16.8581 18 17.2701 18Z" fill="black"/></svg>');
  }
};

createQtySelectors = function () {
  // If there is a normal quantity number field in the ajax cart, replace it with our version
  if ($('input[type="number"]', $cartContainer).length) {
    $('input[type="number"]', $cartContainer).each(function () {
      var $el = $(this),
        currentQty = $el.val();

      var itemAdd = currentQty + 1,
        itemMinus = currentQty - 1,
        itemQty = currentQty;

      var source = $("#AjaxQty").html(),
        template = Handlebars.compile(source),
        data = {
          key: $el.data('id'),
          itemQty: itemQty,
          itemAdd: itemAdd,
          itemMinus: itemMinus
        };

      // Append new quantity selector then remove original
      $el.after(template(data)).remove();
    });
  }
};

qtySelectors = function () {
  // Change number inputs to JS ones, similar to ajax cart but without API integration.
  // Make sure to add the existing name and id to the new input element
  var numInputs = $('input[type="number"]');

  if (numInputs.length) {
    numInputs.each(function () {
      var $el = $(this),
        currentQty = $el.val(),
        inputName = $el.attr('name'),
        inputId = $el.attr('id');

      var itemAdd = currentQty + 1,
        itemMinus = currentQty - 1,
        itemQty = currentQty;

      var source = $("#JsQty").html(),
        template = Handlebars.compile(source),
        data = {
          key: $el.data('id'),
          itemQty: itemQty,
          itemAdd: itemAdd,
          itemMinus: itemMinus,
          inputName: inputName,
          inputId: inputId
        };

      // Append new quantity selector then remove original
      $el.after(template(data)).remove();
    });

    // Setup listeners to add/subtract from the input
    $('.js-qty__adjust').on('click', function () {
      var $el = $(this),
        id = $el.data('id'),
        $qtySelector = $el.siblings('.js-qty__num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);
      var adjustmentType;

      // Add or subtract from the current quantity
      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
        adjustmentType = 'plus';
      } else {
        adjustmentType = 'minus';
        qty -= 1;
        // if (qty <= 1) qty = 1;
      }

      // var gtmData = $qtySelector.closest('[data-product]').data('product');
      // gtmData.quantity = qty;

      if (adjustmentType === 'plus') {
        //triggerGTMAddToCart(gtmData);
      } else if (adjustmentType === 'minus') {
        //triggerGTMRemoveFromCart(gtmData);
      }

      // Update the input's number
      $qtySelector.val(qty);
    });
  }
};

// triggerGTMAddToCart = function (data) {
//   if (window.GTMFunctions && window.GTMFunctions.addToCart) {
//     window.GTMFunctions.addToCart(data);
//   }
// };

// triggerGTMRemoveFromCart = function (data) {
//   if (window.GTMFunctions && window.GTMFunctions.removeFromCart) {
//     window.GTMFunctions.removeFromCart(data);
//   }
// };

validateQty = function (qty) {
  if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

module = {
  init: init,
  load: loadCart,
  qtySelectors: qtySelectors
};

return module;

}(ajaxCart || {}, jQuery));
